import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { APIRequest } from '../../common/Common';
import { filterNonDependentList } from './util';
import { TARGET_YEAR_API } from '../../common/data';

const initialState = {
  isRender: false,
  reload: -1,
  dataList: [],

  //원본데이터
  originalDataList: [],
  //공제 불가 항목
  nonItemList: [],

  selectedDependents: {},

  htmBoyangFlag: '',

  detailData: {},
};

//부양가족 불러오기
export const getDependentsInfo = createAsyncThunk('dependents/getDependentsInfo', async () => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/S3`);
  return response;
});

//부양가족 저장
export const updateDependentsInfo = createAsyncThunk(
  'dependents/updateDependentsInfo',
  async data => {
    const response = await APIRequest(`/${TARGET_YEAR_API}/S3CheckUpdate`, data);
    return response;
  },
);

//부양가족 삭제
export const deleteDependentsInfo = createAsyncThunk(
  'dependents/deleteDependentsInfo',
  async data => {
    const response = await APIRequest(`/${TARGET_YEAR_API}/SA1D`, data);
    return response;
  },
);

//부양가족 상세 불러오기
export const getDependentsDetailInfo = createAsyncThunk(
  'dependents/getDependentsDetailInfo',
  async params => {
    const response = await APIRequest(`/${TARGET_YEAR_API}/S3S`, params);
    return response;
  },
);

//부양가족 상세 저장
export const updateDependentsDetailInfo = createAsyncThunk(
  'dependents/updateDependentsDetailInfo',
  async data => {
    const response = await APIRequest(`/${TARGET_YEAR_API}/S3AE`, data);
    return response;
  },
);

//전년도 부양가족데이터
export const getPreviousDependentsInfo = createAsyncThunk(
  'dependents/getPreviousDependentsInfo',
  async data => {
    const response = await APIRequest(`/${TARGET_YEAR_API}/S3Boyang`, data);
    return response;
  },
);

const dependentsSlice = createSlice({
  name: 'dependents',
  initialState,
  reducers: {
    confirmDelete: (state, action) => {
      const { index } = action.payload;
      state.dataList = state.dataList.filter((_, idx) => idx !== index);
    },
    handleDependentsInfo: (state, action) => {
      state.dataList = action.payload;
    },
    setSelectedDependents: (state, action) => {
      state.selectedDependents = action.payload;
    },
    resetDependentsState: () => initialState, // 상태 리셋 액션 추가
  },
  extraReducers: builder => {
    builder.addCase(getDependentsInfo.pending, state => {
      // state.dataList = [];
      // state.nonItemList = [];
      state.isRender = false;
    });
    builder.addCase(getDependentsInfo.fulfilled, (state, action) => {
      console.log('부양가족 리스트 >>', action.payload);
      const { list, htmBoyangFlag, htm013 } = action.payload;
      let nonDependentList = filterNonDependentList(list, htm013);
      if (htmBoyangFlag) {
        state.htmBoyangFlag = htmBoyangFlag;
        state.dataList = [];
        state.originalDataList = [];
        state.isRender = false;
        state.nonItemList = [];
      } else {
        if (list.length > 0) {
          let copyList = list.map(item => {
            // 총급여(htm013)가 41,470,588 초과이고 본인(htm002 === '0')일 경우 부녀자(htm005)를 2로 변경
            if (item.htm002 === '0' && Number(htm013) > 41470588) {
              return {
                ...item,
                htm001_old: item.htm001,
                htm005: '2',
              };
            }
            return {
              ...item,
              htm001_old: item.htm001,
            };
          });

          state.dataList = copyList;
          state.originalDataList = list;
        }
        state.isRender = true;
        state.nonItemList = nonDependentList;
      }
    });

    builder.addCase(updateDependentsInfo.fulfilled, (state, action) => {
      console.log('부양가족 저장 성공 >>', action.payload);
      const { resultCode } = action.payload;
      if (resultCode === 'OK') {
        state.reload = Math.random();
      }
    });

    builder.addCase(deleteDependentsInfo.fulfilled, (state, action) => {
      console.log('부양가족 삭제 성공 >>', action.payload);
      const { resultCode } = action.payload;
      if (resultCode === 'OK') {
        state.reload = Math.random();
      }
    });

    builder.addCase(getDependentsDetailInfo.fulfilled, (state, action) => {
      console.log('부양가족 상세 성공 >>', action.payload);
      state.detailData = action.payload;
    });

    builder.addCase(getPreviousDependentsInfo.fulfilled, (state, action) => {
      console.log('전년도 부양가족 데이터 성공 >>', action.payload);
      const { resultCode } = action.payload;
      if (resultCode === 'OK') {
        state.reload = Math.random();
      }
    });
    builder.addCase(updateDependentsDetailInfo.fulfilled, (state, action) => {
      console.log('부양가족 상세 저장 성공 >>', action.payload);
      const { resultCode } = action.payload;
      if (resultCode === 'OK') {
        state.reload = Math.random();
      }
    });
  },
});

export const { confirmDelete, handleDependentsInfo, resetDependentsState, setSelectedDependents } =
  dependentsSlice.actions;
export default dependentsSlice.reducer;
